
namespace GeniuzPOS.Member {
    import fld = MbReportSaleByDateRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MbReportSaleByDateGrid extends Serenity.EntityGrid<MbReportSaleByDateRow, any> {
        protected getColumnsKey() { return MbReportSaleByDateColumns.columnsKey; }
        protected getDialogType() { return MbReportSaleByDateDialog; }
        protected getIdProperty() { return MbReportSaleByDateRow.idProperty; }
        protected getInsertPermission() { return MbReportSaleByDateRow.insertPermission; }
        protected getLocalTextPrefix() { return MbReportSaleByDateRow.localTextPrefix; }
        protected getService() { return MbReportSaleByDateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(Date.now()-6);

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            // var q = Q.parseQueryString();
            // if (q["posid"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "PosId");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["posid"];
            //     };
            // }


            return filters;
        }

        
        protected getButtons() {
            var buttons = super.getButtons();
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")
            // Add buttons export excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: MbReportSaleByDateService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }
    }
}